import { lazy } from 'react';

export const OnRamp = lazy(() => import('./OnRamp.component'));
